var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalenderNextButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6911 16.6024L14.321 21.9363C13.8855 22.408 13.1599 22.408 12.7245 21.9363C12.289 21.5009 12.289 20.7753 12.7245 20.3398L17.2963 15.8041L12.7245 11.2322C12.289 10.7968 12.289 10.0712 12.7245 9.63572C13.1599 9.20028 13.8855 9.20028 14.321 9.63572L19.6911 14.9697C20.1265 15.4413 20.1265 16.1307 19.6911 16.6024ZM3 15.8041C3 19.2512 4.41513 22.3715 6.66473 24.621C8.91433 26.9069 12.0348 28.2858 15.5183 28.2858C18.9654 28.2858 22.0857 26.9069 24.3353 24.621C26.6211 22.3714 28 19.2509 28 15.8041C28 12.3207 26.6211 9.20005 24.3353 6.9505C22.0857 4.7009 18.9652 3.28577 15.5183 3.28577C12.035 3.28577 8.91429 4.7009 6.66473 6.9505C4.41518 9.2001 3 12.3206 3 15.8041Z",
    fill: "url(#paint0_linear_982_30645)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_982_30645",
    x1: 3,
    y1: 15.7858,
    x2: 28,
    y2: 15.7858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#232526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414345"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderNextButton);
export default __webpack_public_path__ + "static/media/CalenderNextButton.c396202807d29921520880004b663aba.svg";
export { ForwardRef as ReactComponent };